import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  NgZone,
  ChangeDetectorRef,
} from "@angular/core";
import { OnboardEmployeeFinanceDetails } from "../../shared/models/OnboardEmployeeFinanceDetails";
import { FormGroup, FormControl, FormArray, FormBuilder } from "@angular/forms";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { ComponentIdentificationService } from "../../shared/service/component-identification.service";
import { EmployeeService } from "../../shared/service/employee.service";
import { isNullOrUndefined, isUndefined } from "util";
import { HrEmployeeFinanceDetails } from "../../shared/models/hrEmpFinanceDtls";
import { ToastrService } from "ngx-toastr";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { File_Types } from "../../shared/UploadFileTypes";
import * as _moment from "moment";
import { DatePipe } from "@angular/common";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  MatDialog,
} from "@angular/material";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import { UserService } from "../../shared/service/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-finance-details",
  templateUrl: "./finance-details.component.html",
  styleUrls: ["./finance-details.component.css"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class FinanceDetailsComponent implements OnInit, OnChanges {
  FinanceDetails: any;
  todayDate: Date;
  @Input() EmpId: number;
  @Input() empCode: number;
  @Output("financeDetValue") financeDetValue = new EventEmitter();
  FinanceForm: FormGroup;
  empFinanceDetails: FormArray = this.fb.array([]);
  error: any;
  LoginEmpCode: any;
  NPS: any;
  parentComponentName: string;
  MAX_SIZE: number = 1048576;
  hide: boolean = false;
  @Input() isProfile: boolean;
  @Input() hideCostCenterDiv: boolean = false;
  approveCheckMyProfile: any;
  disableforMyProfile: boolean;
  gettingBasicDet: BasicEmployeeDetails;
  enableReqforFTELoc: boolean = true;
  enableAccountRequired: boolean;
  showDiv: boolean = false;
  result: any;
  isSaved: boolean = false;
  originalFinanceDetails: any;
  originalFinanceAccountDetails: any;
  isLoader: boolean = true;
  costCenters: any[] = [];
  FinanceDtlsDisable: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private _service: OnboardingService,
    private zone: NgZone,
    private changeCom_svc: ComponentIdentificationService,
    private userService: UserService,
    private emp_Svc: EmployeeService,
    private toastr: ToastrService,
    private file_Svc: FileUploadService,
    private fb: FormBuilder,
    public router: Router,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.LoginEmpCode = this.userService.getEmpCode();
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];
      this.initializeParamChange();
    });
    this.isSaved = this.empCode == null ? false : true;
    this.empFinanceDetails = this.fb.array([]);
    this.FinanceForm = this.fb.group({
      empFinanceDetails: this.empFinanceDetails,
      NoOfempFinanceDetails: new FormControl(),
      NpsPran: new FormControl(),
      UAN: new FormControl(),
      SSN: new FormControl(),
      Elig_Med: new FormControl(),
      Elig_NnP: new FormControl(),
      Elig_InC: new FormControl(),
      PF_StartDate: new FormControl(),
      IsEligibleForPF: new FormControl(),
      IsMigratedOnH1: new FormControl(),
      CostCenter: new FormControl(),
      Billability: new FormControl(),
    });
    //this.getSubmitMyProfileData();
    //setTimeout(() => {
    //  this.isLoader = false;
    //}, 1500);
  }

  getRefreshPage() {
    window.location.reload();
  }

  initializeParamChange() {
    //get the login employee code
    this.LoginEmpCode = this.userService.getEmpCode().toString();
    //this.EmpId = this.LoginEmpCode;

    if (!isNullOrUndefined(this.empCode)) {
      if (this.router.url.startsWith("/myprofile/")) {
        if (this.empCode === this.LoginEmpCode) this.isProfile = true;
        else this.router.navigate(["/EmployeeWithoutPermission"]);
      }
    }
  }
  ngOnChanges() {
    this.todayDate = new Date();
   // this.getCostCenters();
    this.changeCom_svc.componentName.subscribe(
      (response) => (this.parentComponentName = response)
    );
    if (this.parentComponentName == "app-hr-employee-details") {
      this.FinanceDetails = new HrEmployeeFinanceDetails();
      if (!isUndefined(this.empCode)) {
        this.getBasicEmployeeByCode().then(() => {
          this.GetHrEmpolyeeFinanceDetails();
        })

      }
    } else {
      this.hide = true;
      this.FinanceDetails = new OnboardEmployeeFinanceDetails();
      this.getBasicEmployeeByCode().then(() => {
        this.GetOnboardEmpolyeeFinanceDetails();
      })
    }
  }

  getCostCenters() {
    this.emp_Svc.getCostCenters().subscribe((data: any) => {
      this.costCenters = data;
    });
  }

  FormInitialization() {
    this.empFinanceDetails = this.fb.array([]);
    this.FinanceForm = new FormGroup({
      NoOfempFinanceDetails: new FormControl(),
      empFinanceDetails: this.empFinanceDetails,
      NpsPran: new FormControl(),
      UAN: new FormControl(),
      SSN: new FormControl(),
      Elig_Med: new FormControl(),
      Elig_NnP: new FormControl(),
      Elig_InC: new FormControl(),
      PF_StartDate: new FormControl(),
      IsEligibleForPF: new FormControl(),
      IsMigratedOnH1: new FormControl(),
      CostCenter: new FormControl(),
      Billability: new FormControl(),
    });
  }

  createChildren(item = null) {
    if (item != null) {
      var row = this.fb.group({
        Id: item.Id,
        EmpCode: item.EmpCode,
        BankAccount: item.BankAccount,
        IFSCCode: item.IFSCCode,
        BankAccountName: item.BankAccountName,
        BankName: item.BankName,
        Branch: item.Branch,
        CancelledChequeFileName: item.CancelledChequeFileName,
        CancelledChequeFilePath: item.CancelledChequeFilePath,
        CancelledChequeFile: item.CancelledChequeFile,
        Primary: item.Primary,
      });
    } else {
      var row = this.fb.group({
        Id: [""],
        EmpCode: [""],
        BankAccount: [""],
        IFSCCode: [""],
        BankAccountName: [""],
        BankName: [""],
        Branch: [""],
        CancelledChequeFileName: null,
        CancelledChequeFilePath: null,
        CancelledChequeFile: [""],
        Primary: [false],
      });
    }
    this.empFinanceDetails.push(row);
  }

  preventCheckboxChange(event: MouseEvent): void {
    if (this.isProfile ? this.isSaved : this.FinanceDtlsDisable) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  preventDialog(event: MouseEvent, index): void {
    if (this.isProfile && this.empFinanceDetails.value[index].Primary) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  GetFinanceDetails() {
    return this.empFinanceDetails.value;
  }

  handleCheckboxChange(index: number) {
    const formArray = this.empFinanceDetails.controls as FormGroup[];
    const currentFormGroup = formArray[index];

    formArray.forEach((formGroup, i) => {
      if (i !== index) {
        formGroup.get("Primary")!.patchValue(false);
      }
    });

    currentFormGroup.get("Primary")!.patchValue(true);
  }

  get pattern(): string {
    return this.isProfile ? "^[0-8]{1}$" : "^[0-9]{1}$";
  }

  onInputChange(event: any) {
    let value = event.target.value;

    if (this.isProfile) {
      event.target.value = value
        .replace(/[^0-9]/g, "")
        .replace(/(\..*)\./g, "$1");
    } else {
      event.target.value = value
        .replace(/[^0-9]/g, "")
        .replace(/(\..*)\./g, "$1");
    }

    if (this.isProfile && value === "9") {
      value = "";
    }

    event.target.value = value;
    this.FinanceDetails.NoOfAccounts = value;
  }

  OnNoOfempFinanceDetailsCount() {
    if (this.FinanceDetails.NoOfAccounts > 0) {
      this.enableAccountRequired = true;
      if (
        this.empFinanceDetails.value != null &&
        this.empFinanceDetails.value.length != 0
      ) {
        if (
          this.empFinanceDetails.value.length <=
          this.FinanceDetails.NoOfAccounts
        ) {
          var arr = this.empFinanceDetails.value;
          var count =
            this.FinanceDetails.NoOfAccounts -
            this.empFinanceDetails.value.length;
          this.empFinanceDetails.clear();
          for (var i = 0; i < arr.length; i++) {
            this.createChildren(arr[i]);
          }
          for (var i = 0; i < count; i++) {
            this.createChildren();
          }
        } else if (
          this.empFinanceDetails.value.length > this.FinanceDetails.NoOfAccounts
        ) {
          var arr = this.empFinanceDetails.value;
          var count =
            this.empFinanceDetails.value.length -
            (this.empFinanceDetails.value.length -
              this.FinanceDetails.NoOfAccounts);
          this.empFinanceDetails.clear();
          for (var i = 0; i < count; i++) {
            this.createChildren(arr[i]);
          }
        }
      } else {
        for (var i = 0; i < this.FinanceDetails.NoOfAccounts; i++) {
          this.createChildren();
        }
      }
      this.cdr.detectChanges();
    } else {
      this.enableAccountRequired = false;
    }
    if (
      this.FinanceDetails.NoOfAccounts == 1 &&
      this.empFinanceDetails.length > 0
    ) {
      const firstAccount = this.empFinanceDetails.at(0) as FormGroup;
      firstAccount.patchValue({ Primary: true });
    }
  }

  getObjectState() {
    const originalFinanceDetails = this.originalFinanceDetails;
    const originalAccountDetails = this.originalFinanceAccountDetails;
    const currentFinanceDetails = this.FinanceDetails;
    const currentAccountDetails = this.empFinanceDetails.value;
    var financeDetVal =
      JSON.stringify(originalFinanceDetails) ===
      JSON.stringify(currentFinanceDetails);
    var BankDetVal =
      JSON.stringify(originalAccountDetails) ===
      JSON.stringify(currentAccountDetails);
    return !(financeDetVal && BankDetVal);
  }

  valuePensionSchemeChange(value) {
    this.NPS = value;
  }

  getfileName(index) {
    if (
      this.gettingBasicDet != null &&
      this.empCode != null &&
      this.empFinanceDetails.value[index].CancelledChequeFileName != null
    ) {
      return (
        this.gettingBasicDet.EmpCode + "_" + (this.gettingBasicDet &&
          this.gettingBasicDet.NamePerRecords ||
          "") + "_Chq" + (index + 1)
      );
    } else if (
      this.EmpId != null && this.gettingBasicDet != null &&
      this.empFinanceDetails.value[index].CancelledChequeFileName != null
    ) {
      return (
        (this.gettingBasicDet.NamePerRecords || "") + "_Chq" + (index + 1)
      );
    } else {
      console.log('null')
      return null
    };
  }

  GetOnboardEmpolyeeFinanceDetails() {
    if (this.EmpId != null) {
      this._service.GetOnboardEmpolyeeFinanceDetails(this.EmpId).subscribe(
        (data: any) => {
          this.empFinanceDetails = this.fb.array([]);
          this.FinanceForm = this.fb.group({
            empFinanceDetails: this.empFinanceDetails,
            NoOfempFinanceDetails: new FormControl(),
            NpsPran: new FormControl(),
            UAN: new FormControl(),
            SSN: new FormControl(),
            Elig_Med: new FormControl(),
            Elig_NnP: new FormControl(),
            Elig_InC: new FormControl(),
            PF_StartDate: new FormControl(),
            IsEligibleForPF: new FormControl(),
            IsMigratedOnH1: new FormControl(),
            CostCenter: new FormControl(),
            Billability: new FormControl(),
          });
          if (data != null) {
            this.FinanceDetails = data;
            this.FinanceDetails.NoOfAccounts =
              this.FinanceDetails.empFinanceDetails != null
                ? this.FinanceDetails.empFinanceDetails.length
                : 0;
            this.FinanceForm.get("NoOfempFinanceDetails").setValue(
              this.FinanceDetails.NoOfAccounts
            );
            this.setDetails(this.FinanceDetails);
            if (this.FinanceDetails.NoOfAccounts > 0) {
              this.zone.runOutsideAngular(() => {
                this.FinanceDetails.empFinanceDetails.forEach((item) => {
                  this.createChildren(item);
                });

                this.zone.run(() => {
                  this.enableAccountRequired = true;
                });
              });
              this.enableAccountRequired = true;
            } else {
              this.FinanceDetails.NoOfAccounts = null;
              this.enableAccountRequired = false;
            }
            if (
              this.FinanceDetails.NoOfAccounts == 1 &&
              this.empFinanceDetails.length > 0
            ) {
              const firstAccount = this.empFinanceDetails.at(0) as FormGroup;
              firstAccount.patchValue({ Primary: true });
            }
            if (this.FinanceDetails.OptedNationalPensionScheme) {
              this.NPS = "true";
            }
          } else {
            this.FinanceDetails.EmpId = this.EmpId;
          }
          this.originalFinanceDetails = JSON.parse(
            JSON.stringify(this.FinanceDetails)
          );
          this.originalFinanceAccountDetails = JSON.parse(
            JSON.stringify(this.empFinanceDetails.value)
          );
          this.financeDetValue.emit(this.FinanceDetails);
        },
        (error) => (this.error = error)
      );
    }
  }

  GetHrEmpolyeeFinanceDetails() {
    if (this.empCode != null) {
      this.emp_Svc.getEmployeeFinanceDetails(this.empCode).subscribe(
        (data: any) => {
          this.empFinanceDetails = this.fb.array([]);
          this.FinanceForm = this.fb.group({
            empFinanceDetails: this.empFinanceDetails,
            NoOfempFinanceDetails: new FormControl(),
            NpsPran: new FormControl(),
            UAN: new FormControl(),
            SSN: new FormControl(),
            Elig_Med: new FormControl(),
            Elig_NnP: new FormControl(),
            Elig_InC: new FormControl(),
            PF_StartDate: new FormControl(),
            IsEligibleForPF: new FormControl(),
            CostCenter: new FormControl(),
            Billability: new FormControl(),
            IsMigratedOnH1: new FormControl(),
          });
          if (data != null) {
            this.FinanceDetails = data;
            this.FinanceDetails.NoOfAccounts =
              this.FinanceDetails.empFinanceDetails != null
                ? this.FinanceDetails.empFinanceDetails.length
                : 0;
            this.FinanceForm.get("NoOfempFinanceDetails").setValue(
              this.FinanceDetails.NoOfAccounts
            );
            this.setDetails(this.FinanceDetails);
            console.log(this.FinanceDetails)
            if (this.FinanceDetails.NoOfAccounts > 0) {
              this.zone.runOutsideAngular(() => {
                this.FinanceDetails.empFinanceDetails.forEach((item) => {
                  this.createChildren(item);
                });

                this.zone.run(() => {
                  this.enableAccountRequired = true;
                });
              });
              this.enableAccountRequired = true;
            } else {
              this.FinanceDetails.NoOfAccounts = null;
              this.enableAccountRequired = false;
            }
            if (
              this.FinanceDetails.NoOfAccounts == 1 &&
              this.empFinanceDetails.length > 0
            ) {
              const firstAccount = this.empFinanceDetails.at(0) as FormGroup;
              firstAccount.patchValue({ Primary: true });
            }
            if (this.FinanceDetails.OptedNationalPensionScheme) {
              this.NPS = "true";
            }
          } else {
            this.FinanceDetails.EmpCode = this.empCode;
          }
          this.originalFinanceDetails = JSON.parse(
            JSON.stringify(this.FinanceDetails)
          );
          this.originalFinanceAccountDetails = JSON.parse(
            JSON.stringify(this.empFinanceDetails.value)
          );
          this.financeDetValue.emit(this.FinanceDetails);
          this.cdr.detectChanges();
        },
        (error) => (this.error = error)
      );
    }
  }

  setDetails(financeDetails: any) {
    this.FinanceForm.get("UAN").setValue(this.FinanceDetails.UAN);
    this.FinanceForm.get("NpsPran").setValue(this.FinanceDetails.NpsPran);
    this.FinanceForm.get("SSN").setValue(this.FinanceDetails.SSN);
    this.FinanceForm.get("CostCenter").setValue(this.FinanceDetails.CostCenter);
    this.FinanceForm.get("Billability").setValue(
      this.FinanceDetails.Billability
    );
    this.FinanceForm.get("Elig_Med").setValue(this.FinanceDetails.Elig_Med);
    this.FinanceForm.get("Elig_NnP").setValue(this.FinanceDetails.Elig_NnP);
    this.FinanceForm.get("Elig_InC").setValue(this.FinanceDetails.Elig_InC);
  }

  getSubmitMyProfileData() {
    this.emp_Svc
      .GetProfileVerificationStatus(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.approveCheckMyProfile = data;
        if (this.isProfile == true) {
          for (var i = 0; i < data.length; i++) {
            this.disableforMyProfile = data[i].Submitted;
          }
          this.FinanceForm.enable();
          this.FinanceForm.get("UAN").disable();
          this.FinanceForm.get("NpsPran").disable();
        }
        //if (this.disableforMyProfile == true) {
        //  this.FinanceForm.disable();
        //  //this.FinanceForm.get("UAN").enable();
        //  //this.FinanceForm.get("NpsPran").enable();
        //}
        ////else {
        ////  this.FinanceForm.enable();
        ////  this.FinanceForm.get("UAN").disable();
        ////  this.FinanceForm.get("NpsPran").disable();
        ////}
      });
  }
  getBasicEmployeeByCode() {
    return new Promise<void>((resolve, reject) => {
      if (this.empCode != null) {
        this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe(
          (data: any) => {
            this.gettingBasicDet = data;
            if (this.gettingBasicDet.ConsultantType == "SubCon") {
              this.enableReqforFTELoc = false;
            } else {
              if (
                this.gettingBasicDet.LocationID != 1 &&
                this.gettingBasicDet.LocationID != 2
              ) {
                this.enableReqforFTELoc = false;
              } else {
                this.enableReqforFTELoc = true;
              }
            }
            this.isLoader = false;
            resolve();
          },
          (error) => {
            this.isLoader = false;
            reject(error);
          }
        );
      } else if (this.EmpId != null) {
        this._service.getEmployeebyId(this.EmpId).subscribe(
          (data: any) => {
            this.gettingBasicDet = data;
            this.gettingBasicDet.EmpCode = this.EmpId;
            this.isLoader = false;
            resolve();
          },
          (error) => {
            this.isLoader = false;
            reject(error);
          }
        );
      }
    });
  }

  async handleFile(event, index: number) {
    if (event.target.files == undefined) {
      this.empFinanceDetails.value[index].CancelledChequeFile = null;
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      //  Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        this.empFinanceDetails.value[index].CancelledChequeFile =
          await this.file_Svc.readAndUploadFile(files);
        this.empFinanceDetails.value[index].CancelledChequeFilePath = null;
        this.empFinanceDetails.at(index).patchValue({
          CancelledChequeFilePath: null,
        });
      } else {
        this.toastr.warning(
          " File: " +
          files[0].name +
          " exceeds 1MB hence it cannot be uploaded."
        );
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
    }
    this.cdr.detectChanges();
  }

  deleteFieldValue(index) {
    const message = `Please confirm if you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.empFinanceDetails.value.splice(index, 1);
          var array = this.empFinanceDetails.value;
          this.FinanceDetails.NoOfAccounts = array.length;
          this.empFinanceDetails.clear();
          for (var i = 0; i < array.length; i++) {
            this.createChildren(array[i]);
          }
          this.cdr.detectChanges();
          this.financeDetValue.emit(this.FinanceDetails);
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  fetchURl(url) {
    this.emp_Svc
      .getDownloadURL(url)
      .subscribe((data: any) => {
        window.open(data, '_blank');
      });
  }

  validFileType(file) {
    let types = File_Types;
    return types.includes(file.type);
  }
}
